import { StoryblokComponent } from "@storyblok/react";
import { Layout } from "./components/layout";
import { LoadingComponent } from "./components/LoadingComponent";
import { LoadErrorPage, NotFoundPage } from "./components/StatusPage";
import { getEnvironmentVersion } from "./utils/getEnvironmentVersion";
import { ScrollRestoration, useParams } from "react-router-dom";
import { MetaTags } from "./components/MetaTags";
import { useDataLayerPageView } from "./utils/useDataLayerPageView";
import { useStory } from "./utils/useStory";

// `storySlug` pins the Storyblok story for routes whose URL isn't a story
// path (e.g. the overview's /community/category/<slug> filter pages).
function App({ storySlug }) {
  const { "*": pathSlug } = useParams();
  const slug = storySlug ?? pathSlug;
  useDataLayerPageView();

  const { status, story } = useStory(slug, {
    version: getEnvironmentVersion(),
    resolve_relations: ["blogpost.related_posts"],
  });

  return (
    <Layout>
      {/* Top of page on new navigations (pagination, post-to-post links);
          previous position on back/forward. */}
      <ScrollRestoration />
      {status === "not-found" ? <NotFoundPage /> : null}
      {status === "error" ? <LoadErrorPage /> : null}
      {status === "loading" || status === "found" ? (
        <>
          <MetaTags story={story} />
          <LoadingComponent loading={!story?.content}>
            <StoryblokComponent blok={story?.content} />
          </LoadingComponent>
        </>
      ) : null}
    </Layout>
  );
}

export default App;
